<template>
  <Popover ref="cancelledItemPopover" :showHeader="true" headerTitle="Item Cancelled">
    <div class="order-item-popover-content order-item-error-popover-content" v-if="item">
      Notes:<br />
      <ul v-html="convertNewlinesToListItems(item.cancelledReason)" class="popover-list"></ul>
      <p>Cancellation Charged: {{formatBoolean(item.chargeCancelFees)}}</p>
    </div>
  </Popover>
</template>


<script>
import Popover from '@/components/popover.vue'

export default {
  components: {
    Popover
  },
  props: {
    item: Object
  },
  methods: {
    displayFromElement(element) {
      this.$refs.cancelledItemPopover.displayFromElement(element)
    }
  }
}
</script>